import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=6fe749c6&scoped=true&"
import script from "./GetInTouch.vue?vue&type=script&lang=ts&"
export * from "./GetInTouch.vue?vue&type=script&lang=ts&"
import style0 from "./GetInTouch.vue?vue&type=style&index=0&id=6fe749c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe749c6",
  null
  
)

export default component.exports